import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreviewError } from '../../responses/previewTransformationReponse';

@Component({ standalone:false,
  selector: 'app-show-file-validation-dialog',
  templateUrl: 'show-file-validation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['show-file-validation-dialog.component.scss']
})
export class ShowFileValidationDialogComponent {
  title: string = "Title";
  message: string = "";
  errorCount: number = 0;
  okButtonText = "OK";

  success:boolean = false;
  errors?:PreviewError;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ShowFileValidationDialogComponent>) {
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        this.success=data.success?data.success:true;
        this.errors=data.errors?data.errors:undefined;
        if (data.buttonText) {
            this.okButtonText = data.buttonText.ok || this.okButtonText;
        }
        if(data.errorCount) this.errorCount = data.errorCount;
    }
  }
  
  onOKClick(): void {
    this.dialogRef.close(false);
  }

}